import React, { useEffect } from "react";
import AllRoutes from "./router/AllRoutes";
import QueryProvider from "./providers/QueryProvider";
import AOS from "aos";
import "aos/dist/aos.css";
import "photoswipe/dist/photoswipe.css";
import { ToastContainer } from "react-toastify";
import TagManager from "react-gtm-module";
// import FirebaseConnectionTest from "./components/dev/FirebaseConnectionTest";


const tagManagerArgs = {gtmId: 'GTM-KTRX2DT'}
TagManager.initialize(tagManagerArgs)

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return ( 
    <QueryProvider>
      <div className="tokyo_tm_all_wrap">
        {/* <FirebaseConnectionTest /> */}
        <AllRoutes />
        <ToastContainer />
      </div>
    </QueryProvider>
  );
};

export default App;
